import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { userApiClient } from '@/setup/api'

export type IGetRestaurantReviewsQueryParams = {
    restaurantSlug: string
    page: number
}

export const getRestaurantReviewsQueryOptions = (
    params: IGetRestaurantReviewsQueryParams,
    locale: string
) =>
    userApiClient.queryOptions(
        'get',
        '/web/restaurants/{restaurantSlug}/reviews',
        {
            params: {
                path: { restaurantSlug: params.restaurantSlug },
                query: { page: params.page },
            },
            headers: { 'accept-language': locale },
        },
        { enabled: !!params.restaurantSlug && params.page > 0 }
    )

export function useGetRestaurantReviewsQuery(params: IGetRestaurantReviewsQueryParams) {
    const locale = useLocale()

    return useQuery(getRestaurantReviewsQueryOptions(params, locale))
}
